<div class="rv-center my-medium">
  <logo></logo>
</div>
<form class="rv-grid large" (ngSubmit)="_.validateAndSubmit()">
  <div class="rv-rows large">
    <div *ngIf="!_.reasonQueryParam" class="rv-title-05 bold rv-center">
      Forgot password?
    </div>
    <div
      *ngIf="_.reasonQueryParam == 'forced'"
      class="rv-title-05 bold rv-center"
    >
      Reset your password to log back in
    </div>
    <div class="body-paragraph rv-center">
      Enter your email address and we'll send you a reset link.
    </div>
  </div>
  <div class="rv-rows large">
    <riv-text-field
      name="email"
      type="email"
      label="Email"
      placeholder="Enter your email"
      [value]="_.email"
      (valueChange)="_.setEmail($event); _.clearAllErrors()"
      size="large"
      [state]="_.emailHasIssue ? 'error' : 'valid'"
    ></riv-text-field>
    <submit-error *ngIf="_.clientSideError">
      {{ _.clientSideError }}
    </submit-error>
    <submit-error *ngIf="_.serverSideError">
      {{ _.serverSideError }}
    </submit-error>
    <button
      rivButton
      variant="primary"
      [full]="true"
      size="xlarge"
      type="submit"
      [disabled]="_.submitLoad.loading"
      class="rv-center"
    >
      {{ _.submitLoad.loading ? 'Submitting...' : 'Submit' }}
    </button>
    <button
      rivButton
      variant="basic"
      [full]="true"
      size="xlarge"
      routerLink="/login"
      [queryParams]="{ email: _.email }"
      class="rv-center"
    >
      Back to login
    </button>
  </div>
</form>
<div *ngIf="!_.envIsZelis" class="rv-explanation my-small rv-center">
  Need help? <a class="rv-link" (click)="openIntercom()">Contact support.</a>
</div>
